import styled from 'styled-components';
import { Button } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';

export const BulkEditFormLayout = styled.div`
  display: grid;
  grid-gap: 12px;
  padding: 20px 32px;
`;

export const BulkEditFormFieldsLayout = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 4fr 2fr 3fr 2fr;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0deda;
`;

export const FormGroup = styled.div`
  align-items: flex-start;
  display: grid;
  grid-gap: 4px;
`;

export const TransactionNameFieldsLayout = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-column-gap: 2px;
`;

export const Report1099FormFieldsLayout = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 4fr 2fr 100px 4fr;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0deda;
`;

export const UntagButton = styled(Button)`
  margin-top: 25px;
  border: none;
  background-color: ${colors.copper};
  color: ${colors.white};

  :hover {
    background-color: ${colors.pipe};
    color: ${colors.white};
  }
`;

export const BulkEditFormActions = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr repeat(2, 100px);
`;
